import type { TmsInvoiceRow, TmsLoadRow } from '@numeo/types-main-web-app'
import { formatUsd } from './format'

/** An upcoming load whose pickup has passed: its state reads so before any click. */
export const pickupPassedOf = (row: TmsLoadRow): boolean => row.pickup_passed === true

/** The pickup time a row's overdue line dates. */
export const pickupAtOf = (row: TmsLoadRow): string | null => row.pickup_at

/** The stages a load is still on the road or waiting to be picked up in. */
const OPEN_STAGES: TmsLoadRow['status'][] = ['upcoming', 'dispatched', 'in_transit']

/** A load whose delivery date has passed while it is still open (not delivered, cancelled or a TONU): its state reads so before any click. */
export const deliveryPassedOf = (row: TmsLoadRow): boolean => row.delivery_passed === true && !row.tonu && OPEN_STAGES.includes(row.status)

/** A load billed through Amazon (Relay): its state, with no action (it is never invoiced from the chat). */
export const AMAZON_STATE = 'Billed through Amazon'

/** A TONU cancellation's state: it bills its fee, so the amount is the fee. */
export const tonuStateOf = (amount: number | null | undefined): string => `Cancelled · TONU ${formatUsd(amount)}`

/** The invoice action's label: a TONU cancellation bills its fee, and the action says so. */
export const invoiceLabelOf = (tonu: boolean | undefined): string => (tonu ? 'Invoice TONU' : 'Invoice')

/** A Ready-tab row's state word: billed through Amazon, a TONU cancellation, or ready to invoice. */
export const readyStateOf = (row: Pick<TmsInvoiceRow, 'billed_through_amazon' | 'tonu' | 'amount_due_usd'>): string => {
    if (row.billed_through_amazon) return AMAZON_STATE
    if (row.tonu) return tonuStateOf(row.amount_due_usd)
    return 'Ready to invoice'
}

/** The invoice a row read again says it is on (its number), or undefined when the row is not invoiced. A row with no number reads "—". */
export const freshInvoicedOf = (row: Pick<TmsInvoiceRow, 'status_group' | 'invoice_number'>): string | undefined =>
    row.status_group === 'invoiced' ? (row.invoice_number ?? '—') : undefined
